import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import DataState from '../../../Types/DataState';
import ContainerWrapper from './ContainerWrapper';
import ReviewedContact from '../../CoachingNotes/ConsolidatedContacts/Tab/ReviewedTab';
import { Profile } from '../../../Types';
import {
  ConsolidatedContact,
  ContactStatusOptionsObject,
} from '../../../api/CoachingNotes/schema';
import { StateContext } from '../../../GlobalStateStore';

interface ContactReviewContainerProps {
  profile: Profile;
  state: string;
  refreshContacts: () => void;
  contacts: ConsolidatedContact[];
  userID: string;
  sourcePage?: string;
}

const ContactReviewContainer: React.FC<ContactReviewContainerProps> = ({
  profile,
  state,
  refreshContacts,
  contacts,
  userID,
  sourcePage,
}: ContactReviewContainerProps): React.ReactElement => {
  const [reviewedList, setReviewedList] = useState<ConsolidatedContact[]>([]);
  const globalState = useContext(StateContext);
  const { inspireOptions } = globalState.state;
  const { isTm } = inspireOptions.data;

  useEffect(() => {
    setReviewedList(
      contacts.filter(
        c =>
          c.contactStatus === ContactStatusOptionsObject.REVIEWED ||
          c.contactStatus === ContactStatusOptionsObject.DELIVERED
      )
    );
  }, [contacts]);

  return (
    <>
      <Row spacingInset='400 none' spacing='none'>
        <Heading level={1} type='h400'>
          <FormattedMessage
            id='cs_perfportal_contactReviews'
            defaultMessage='Contact reviews'
            description='header of Contacts Reviews on dashboard'
          />
        </Heading>
      </Row>
      <ContainerWrapper
        loading={state === DataState.LOADING}
        loaded={state === DataState.LOADED}
        error={state === DataState.ERROR}
      >
        <Row spacingInset='none none 400' spacing='none'>
          <ReviewedContact
            contacts={reviewedList}
            username={profile.user.userName}
            userID={userID}
            refreshContacts={refreshContacts}
            sourcePage={sourcePage}
            isTm={isTm}
          />
        </Row>
      </ContainerWrapper>
    </>
  );
};

export default ContactReviewContainer;
